import { render, staticRenderFns } from "./ResendEmail.vue?vue&type=template&id=6fb745d0&scoped=true"
import script from "./ResendEmail.vue?vue&type=script&lang=js"
export * from "./ResendEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb745d0",
  null
  
)

export default component.exports